import React from "react";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";
import { Badge, Button, Spin, Tag, Tooltip } from "antd";
import moment from "moment";
import { useMessage } from "../MessageProvider/MessageProvider";
import { CustomersStore } from "../../Stores/Customers/CustomersStore";
import { CiRedo } from "react-icons/ci";

export default function CustomersList() {
  const messageApi = useMessage();
  const { id } = useParams();
  const { data, loading, error, fetchData, updateItem, searchCustomers } =
    CustomersStore();

  const copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      messageApi.open({
        type: "success",
        content: "Copied!",
      });
    } catch (err) {
      messageApi.open({
        type: "success",
        content: "Failed to copy!",
      });
    }
  };

  if (loading) {
    return (
      <div className=" w-[100%] pt-[200px] flex justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (data?.length == 0) {
    return (
      <div class="text-center">
        <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
          Klient mavjud emas
        </p>
        <div class="mt-10 flex items-center justify-center gap-x-6">
          <Button
            icon={<CiRedo />}
            onClick={() => {
              fetchData();
            }}
            class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          ></Button>
          <Link to="/yukxati/" class="text-sm font-semibold text-gray-900">
            Asosiy sahifa <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
      </div>
    );
  }
  return (
    // className="relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 max-w-[900px] m-auto w-[100%] flex flex-row items-center justify-between text-[12px]"
    <div className=" w-[100%]">
      {data?.map((el) => {
        return (
          <Link
            key={el?.id}
            to={"/customers/" + el?.id}
            className={
              id == el?.id
                ? "relative block m-auto shrink-0 px-2 py-2 w-[100%]  text-stone-900 text-bold  cursor-pointer   border-b-[1px] border-b-[#bfbfbf36] hover:text-sky-400  bg-[#bfbfbf36]"
                : "relative block m-auto shrink-0 px-2 py-2 w-[100%]  text-stone-900 text-bold  cursor-pointer   border-b-[1px] border-b-[#bfbfbf36] hover:text-sky-400 "
            }
          >
            <div className=" before:content-[''] before:absolute before:bg-[#00fc37] before:z-0 before:bottom-0 before:left-0 before:h-[8px] before:w-[10%]">
              <div className="flex flex-row gap-1 justify-between mb-1 z-4">
                <p
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  className="z-1 text-[18px] md:text-[14px] text-[#111827] p-0 m-0 col-span-2"
                >
                  {el.id}- {el.name}
                </p>
                <p className="text-[17px] md:text-[14px] text-[#6b7280]  p-0 m-0 z-1">
                  <Tooltip
                    sx={{ fontSize: "10px" }}
                    className="text-[14px]"
                    title={`yaratildi: ${el?.created_at} \n updated: ${el?.updated_at}`}
                  >
                    {moment(el.created_at).format("DD.MM.YYYY")}
                  </Tooltip>
                </p>
              </div>
              <div className="flex flex-row gap-1 justify-between pl-1">
                <div className="flex flex-row gap-1  items-center justify-center">
                  <h2 className="text-[14px] text-[#6b7280] p-0 m-0 z-1">
                    Tel: {el.phone}
                  </h2>
                  <p className="text-[14px] text-[#6b7280]  p-0 m-0 z-1">
                    INN: {el.INN}
                  </p>
                </div>
                <div className="relative z-0 flex flex-row items-center justify-center">
                  <Tag className="!z-0" color="green">
                    {el?.type}
                  </Tag>

                  {data?.verify ? (
                    <img
                      src="https://www.notion.so/icons/verified_blue.svg?mode=dark"
                      width={20}
                      height={20}
                    />
                  ) : (
                    <Badge key={1} color={"red"} text={""} />
                  )}
                </div>
              </div>
            </div>
          </Link>
        );
      })}

      <p className="text-center text-[#bfbfbf] text-[14px] p-4">No more...</p>
    </div>
  );
}
